import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-24 bg-cream text-text-dark" data-id="element-136">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-137">
        <FadeIn data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-16 font-serif" data-id="element-139">
            Qué cambia en 90 días
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-140">
          <FadeIn delay={0.1} data-id="element-141">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-142">
              <div className="text-4xl md:text-5xl font-bold text-gold mb-4 font-serif" data-id="element-143">
                60-100
              </div>
              <div className="text-lg text-navy font-semibold uppercase tracking-wide" data-id="element-144">
                Puntos
              </div>
              <p className="text-text-muted mt-2 text-sm" data-id="element-145">
                Aumento promedio estimado
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-146">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark transform md:-translate-y-4" data-id="element-147">
              <div className="text-4xl md:text-5xl font-bold text-gold mb-4 font-serif" data-id="element-148">
                $250
              </div>
              <div className="text-lg text-navy font-semibold uppercase tracking-wide" data-id="element-149">
                Al Mes
              </div>
              <p className="text-text-muted mt-2 text-sm" data-id="element-150">
                Ahorro promedio en intereses
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-151">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-152">
              <div className="text-4xl md:text-5xl font-bold text-gold mb-4 font-serif" data-id="element-153">
                30-45
              </div>
              <div className="text-lg text-navy font-semibold uppercase tracking-wide" data-id="element-154">
                Días
              </div>
              <p className="text-text-muted mt-2 text-sm" data-id="element-155">
                Para ver primeros resultados
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-156">
          <p className="text-lg md:text-xl text-text-muted font-sans leading-relaxed max-w-3xl mx-auto" data-id="element-157">
            Siguiendo este proceso, la mayoría de los usuarios ven la
            eliminación de sus primeras colecciones en el primer ciclo de
            disputa. Al limpiar solo 2 o 3 registros negativos, es común ver un
            salto significativo en el puntaje FICO.
          </p>
        </FadeIn>
      </div>
    </section>;
}